import React from "react";
import { connect } from 'react-redux';

import { Typography, Paper } from '@material-ui/core';

import { setSurveyAnswer } from '../../../actions/surveyActions';

class SurveyPageMultipleQuestions extends React.Component {
    checkIfSelectedAnswer(option) {
        return (option !== null && this.props.surveyData.currentAnswer) ? this.props.surveyData.currentAnswer.findIndex( item => item === option) : -1;
    }

    onSelectAnswer(value) {
        const noneValue = 'none';
        let currentAnswer = this.props.surveyData.currentAnswer;

        let answer = currentAnswer ? [...currentAnswer] : [];
        //check if value selected is None
        if (value === noneValue) {
            //If already selected answer is None, then remove it, or else add it
            answer = currentAnswer && currentAnswer[0] === noneValue ? [] : [noneValue];
        }
        //check if answer already selected is None
        else if (answer.length === 1 && answer[0] === noneValue) {
            answer = [value];
        }
        //check if item is already selected
        else {
            let index = this.checkIfSelectedAnswer(value);
            //If item exists, remove the item else add it
            if (index > -1) {
                answer.splice(index, 1);
            }else {
                answer.push(value);
            }
        }
        answer = answer && answer.length === 0 ? null : answer;
        this.props.setSurveyAnswer(answer);
    }

    render() {
        return (
            <>
                <Typography classes={{root: "survey-instructions"}}>
                    {this.props.translations["SURVEY.OPTIONS_MCQ_HEADING"]}
                </Typography>

                <div className="survey-options-container">
                    {this.props.surveyData.currentQuestionObject.choices.map(item => (
                        <Paper key={item.order} classes={{root: "survey-options-wrapper"}} order={item.order} value={item.value.toString()} className={this.checkIfSelectedAnswer(item.value) !== -1 ? "selected-answer" : ""} onClick={ () => this.onSelectAnswer(item.value) }>
                            <Typography classes={{root: "survey-options-text"}}>
                                {item.text}
                            </Typography>
                        </Paper>
                    ))}
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        surveyData : state.surveyData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSurveyAnswer: (ans) => {dispatch(setSurveyAnswer(ans))}
    }
}
    
export default connect(mapStateToProps, mapDispatchToProps)(SurveyPageMultipleQuestions);